export default __webpack_public_path__ + "static/media/button_icon_04.93383b53.svg";